import {$app} from '../app'
import Query from '../app/Query'
import {CUSTOMER_VISIT_EVENT_TYPE_ID, LOBSTER_FRIEND_STATUS_ID} from '../helpers/misc'

export async function getPoints() {

  try {

    const {available_points = 0} = await $app.$api({
      action: 'carecloud_api',
      route: `wallet/actions/points-overview`
    })

    return available_points

  } catch (error) {

    console.log(error)

  }

}

export async function getStatuses() {

  try {

    const res = await $app.$api({
      action: 'carecloud_user_api',
      route: (new Query('status-records')).add('valid_now', true).route

    })

    return res

  } catch (error) {

    console.log(error)

  }

}

export async function isAccountLobsterFriend() {
  const {status_records} = await getStatuses()

  return status_records.some(({status_id}) => status_id === LOBSTER_FRIEND_STATUS_ID)

}

export async function getLastVisitForBasicStatus() {
  try {

    const {customer_events, total_items} = await $app.$api({
      action: 'carecloud_user_api',
      route: (new Query('events'))
        .add('count', 1)
        .add('event_type_id', CUSTOMER_VISIT_EVENT_TYPE_ID)
        .add('sort_direction', 'desc').route

    })

    return {visit: customer_events.shift(), total_items}

  } catch (error) {

    console.log(error)

  }
}

export async function getLastVisitForLobsterFriendStatus () {
  try {

    const {total_items, purchases} = await $app.$api({
      action: 'carecloud_user_api',
      route: (new Query('purchases'))
        .add('count', 1)
        .add('sort_field', 'payment_time')
        .add('sort_direction', 'desc').route

    })

    return {visit: purchases[0], total_items}

  } catch (error) {

    console.log(error)

  }

}

export async function getTotalVisitsForBasicStatus() {
  try {

    const {total_items} = await $app.$api({
      action: 'carecloud_user_api',
      route: (new Query('events'))
        .add('count', 1)
        .add('event_type_id', CUSTOMER_VISIT_EVENT_TYPE_ID)
        .add('sort_direction', 'desc').route

    })

    return total_items

  } catch (error) {

    console.log(error)

  }
}

export async function getTotalVisitsForLobsterFriendStatus() {
  try {

    const {total_items} = await $app.$api({
      action: 'carecloud_user_api',
      route: (new Query('purchases'))
        .add('count', 1)
        .add('sort_field', 'payment_time')
        .add('sort_direction', 'desc').route

    })

    return total_items

  } catch (error) {

    console.log(error)

  }
}

export async function getTotalVisits() {
  return (await isAccountLobsterFriend()) ? await getTotalVisitsForLobsterFriendStatus() : await getTotalVisitsForBasicStatus()
}

export async function getAccountActiveCard() {

  try {

    const {cards} = await $app.$api({
      action: 'carecloud_user_api',
      route: (new Query('cards'))
        .add('is_valid', true)
        .add('count', 1).route
    })

    if(cards.length !== 1)
      throw new Error('Nemáte žádnou kartu')

    return {
      number: cards[0].card_number,
      valid_to: cards[0].valid_to
    }

  } catch (error) {

    console.log(error)

  }

}

export async function getLastAppliedVoucher() {
  try {

    const {vouchers, total_items} = await $app.$api({
      action: 'carecloud_user_api',
      route: (new Query('vouchers'))
        .add('is_applied', true)
        .add('count', 1).route
    })


    return {
      voucher: vouchers[0],
      total_items,
    }

  } catch (error) {

    console.log(error)

  }
}

export async function getPointsOverview () {
  try {

    return await $app.$api({
      action: 'carecloud_api',
      route: 'wallet/actions/points-overview'
    })

  } catch (error) {

    console.log(error)

  }

}